// FTR F19 — utilities

import type {GeneratedDoc} from './types'

export const fmt_amount = (v: number) =>
	new Intl.NumberFormat('sv-SE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(v)

export const ensureSpinKeyframes = () => {
	if (typeof document === 'undefined') return
	if (document.getElementById('ftr-f19-spin')) return
	const style = document.createElement('style')
	style.id = 'ftr-f19-spin'
	style.textContent = '@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }'
	document.head.appendChild(style)
}

/** generate export batch xlsx buffer from generated results (browser-compatible) */
export const generate_export_batch_buffer = async (results: GeneratedDoc[]): Promise<ArrayBuffer> => {
	const {archetype_to_field_sheet, archetype_project} = await import('@ts/mod/ftr_f19/csa_basic/mod')
	const {export_batch_archetype_excel} = await import('@ts/mod/ftr_f19/csa_basic/cpt/mod')
	const {field_sheet_to_sheet} = await import('@ts/mod/excel_gen/field_sheet')
	const {workbook_render} = await import('@ts/mod/excel_gen/render')

	const fs_def = archetype_to_field_sheet(export_batch_archetype_excel, {name: 'Exporter', color: 'bbccdd'})
	const now_iso = new Date().toISOString().slice(0, 10)

	fs_def.data = results.map(r => archetype_project(export_batch_archetype_excel, {
		export_batch_item: {
			doc: r.short,
			exported_at: now_iso,
			author: r.author,
			total_amount: Math.round(r.net_total * 100) / 100,
			ccy: r.ccy,
			line_count: String(r.line_count),
			payment_method: '',
			file_name: `${r.short}.pdf`,
		},
	})) as Record<string, unknown>[]

	const sheet = field_sheet_to_sheet(fs_def)
	return workbook_render({sheets: [sheet]})
}
